import {memo} from 'react'
import {Icon} from '../../../icon'
import {Layout} from '../../../layout'
import {Text} from '../../../text'
import {useSelectContext} from '../../../select/context'

export const SelectClearAll = memo(() => {
	const {showClearAll, showToggleAll, items, updateValue, getSelectedItems} = useSelectContext()

	if (!showClearAll || showToggleAll) return null

	const clearableItems = getSelectedItems(items.map(item => item.data).filter(Boolean)).filter(item => !item.disabled)

	const minItemsSelected = showClearAll.showAtCount || 1
	// This component is always mounted in the DOM, but its visibility is controlled via a height transition.
	// When visibility changes, the component's height animates to smoothly show or hide its content.
	const isVisible = clearableItems.length >= minItemsSelected

	const handleClearAll = () => {
		updateValue(clearableItems)
	}

	return (
		<Layout
			className="select-clear-all"
			onClick={handleClearAll}
			height={isVisible ? 40 : 0}
			padding="0 16"
			vertical="center"
			gap={12}
			width="full"
			borderBottom={isVisible}
		>
			<Icon name="trash" />
			<Text bold truncate t={showClearAll.t || 'clear'} countSuffix={clearableItems.length} noTextSelect />
		</Layout>
	)
})
